import React from "react";

import './styles.scss';

const Footer = () => (
  <footer className="app-footer bg-light">
    <p className="app-footer_copywright">
      &copy; 2020 HomePlantTracker
    </p>
  </footer>
);

export default Footer;
